import { useEffect, useState, useRef} from 'react';
import axios from 'axios';
import {getAbbrState} from './helpers/helpers.js';



if (typeof window.kw_from_search === 'undefined') window.kw_from_search = "";
if (typeof window.predefined_kw === 'undefined') window.predefined_kw = "";
if (typeof window.predefined_cats === 'undefined') window.predefined_cats = [];
if (typeof window.predefined_job_types === 'undefined') window.predefined_job_types = [];
if (typeof window.predefined_state === 'undefined') window.predefined_state = "";
if (typeof window.predefined_city === 'undefined') window.predefined_city = "";
//let source = axios.CancelToken.source();

const useFetchData = (jobParams={}) => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        //source = axios.CancelToken.source();
        const source = axios.CancelToken.source() // <-- 1st step
        const keywords = jobParams.hasOwnProperty('keywords') ? jobParams['keywords'] : window.kw_from_search;
        const categories = jobParams.hasOwnProperty('categories') ? jobParams['categories'] : null;
        const states = jobParams.hasOwnProperty('states') ? jobParams['states'] : null;
        const cities = jobParams.hasOwnProperty('cities') ? jobParams['cities'] : null;
        const sort_id = jobParams.hasOwnProperty('sort_id') ? jobParams['sort_id'] : null
        const sort_id_qs = sort_id !== null && `sort_id=${sort_id}`;
        const search_after_count = jobParams.hasOwnProperty('search_after_count') ?  jobParams['search_after_count'] : null
        const search_after_count_qs = search_after_count !== null && `search_after_count=${search_after_count}`;
        const from = jobParams.hasOwnProperty('from') ? jobParams['from'] : 0;
        const qs_params = [sort_id_qs, search_after_count_qs].filter(Boolean).join('&');
        let sort = [{"modified_at.date": "desc"}]
         
        

        //console.log("qs_params: " + qs_params)

        const queryParams = (keywords, filters) => {
            let query = {"bool" : {}},
                facet_filter = [{"bool" : {
                    "must" : [{"term": {"job_board_url.enum": "http://www.sunbeltstaffing.com"}}]
                }}]

            if (keywords !== null && keywords !== "") {
                keywords = keywords.replace(/\bor\b/gi, "operating room"); //fixes OR, OR Nurse, OR-RN etc since elastic reserves OR for operators

                query["bool"] = {
                    "must" : [{
                        "multi_match" : {
                            "query" : keywords,
                            "fields" : ["job_title^3", "job_city^2", "job_description_raw", "job_category", "job_type"],
                            operator: "and"
                        }
                    }]
                }

                sort = [
                    { "_score": { "order": "desc" }},
                    { "modified_at.date":   { "order": "desc",  "mode": "min" }}
                ]
                
                ///if (window.kw_from_search) Object.assign(query["bool"]["must"]["multi_match"], {operator: "and"});
                
            }

            if (window.predefined_kw !== "") {
                (query["bool"]["must"] ??= []).push({"match_phrase": {"job_title": {"query": window.predefined_kw}}})
            }
            
            if (states !== null && states.length > 0) {
                facet_filter[0]["bool"]["must"].push({"terms": {"job_state_abbr.enum": states}})
            }
            else if (window.predefined_state !== "") {
                facet_filter[0]["bool"]["must"].push({"terms": {"job_state_abbr.enum": [getAbbrState(window.predefined_state)]}})
            }

            if (cities !== null && cities.length > 0) {
                facet_filter.push({"terms": {"job_city.enum": cities}})
            }
            else if (window.predefined_city !== "") {
                facet_filter.push({"terms": {"job_city.enum": [window.predefined_city]}})
            }
           
            if (categories !== null && categories.length > 0) {
                facet_filter.push({"terms": {"job_category.enum": categories}})
            }
            else if (window.predefined_cats.length>0) {
                //use predefined cats
                facet_filter[0]["bool"]["must"].push({"terms": {"job_category_id.float": JSON.parse(window.predefined_cats)}})
            }
            else if (window.predefined_job_types.length>0) {
                //use predefined cats
                facet_filter[0]["bool"]["must"].push({"terms": {"job_type_id.float": JSON.parse(window.predefined_job_types)}})
            }

            //facet_filter[0]["bool"]["must"].push({"range": {"modified_at.date": {"gte": "now-31d/d", "lt": "now/d"}}}) //only pull the last 30 days
            facet_filter[0]["bool"]["must"].push({"range": {"modified_at.date": {"gte": "now-31d/d"}}}) //only pull the last 30 days
            
            
            //console.log("THE FACETS: " + JSON.stringify(facet_filter));

            query["bool"]["filter"] = facet_filter;


            //console.log("THE QUERY: " + JSON.stringify(query));
            return query;
        }

        const compiledData = {
            "from": from,
            "size": 1000,
            "query": queryParams(keywords),
            "aggs": {
                "job_count": {
                        "value_count" : { "field" : "job_board_url.enum" } 
                },
                "categorieslist": {
                    "terms": { 
                        "field": "job_category.enum",
                        "size": 200,
                        "order": {"_key" : "asc"}
                        }  
                },
                "stateslist": {
                        "terms": { 
                            "field": "job_state_abbr.enum",
                            "size": 51,
                            "order": {"_key" : "asc"}
                        },
                        "aggs": {
                            "city-list": {
                            "terms": {
                                "field": "job_city.enum",
                                "size": 200,
                                "order": {"_key" : "asc"}
                            }
                        }
                    }
                }
            },
            "fields": [
                "job_order_id",
                "job_title",
                "job_category",
                "job_city",
                "job_state_abbr",
                "job_postal",
                "job_description",
                "modified_at"
            ],
            "sort": sort,      
            "_source": false  
        }
        

      //  console.log("compiledJSONData: " + JSON.stringify(compiledData));
        //console.log("sort_id: " + sort_id); 
        

        const fetchData = async (compiledData, qs_params) => {
           
        
            try {
                //if (ref) {cancelAllCalls(); console.log("ABORT")};
                // https://proxy.sunbeltstaffingjobs.com:4143/post_job_search.php?
                // /wp-content/themes/sunbelt/classes/post_job_search.php?
                
                setLoading(true);
                const { data: response } = await axios({
                    method: 'post',
                    url: 'https://proxy.sunbeltstaffingjobs.com:4143/post_job_search.php?' + qs_params,
                    cancelToken: source.token,
                    headers: {
                        'Content-Type' : 'application/json',
                        'Accept': 'Token',
                        "Access-Control-Allow-Origin": "*",
                    },
                    data: JSON.stringify(compiledData)
                });
                setData(response);
                //console.log("the response: " +  response);
            } 
            catch (error) {
                console.error("there was an error: " + error)
            }
            finally {
                setLoading(false);
                //if (source) source.cancel("Landing Component got unmounted");
            }
            
            

        };

        fetchData(compiledData, qs_params);

        return () => {
            if (source) source.cancel() // <-- 3rd step
          }
    }, [jobParams]);

    return {data, loading};
};

export default useFetchData;